import React from "react";
import { NavigateFunction } from "react-router-dom";
import { useAnalyticsStore } from "../../../Analytics/AnalyticsStore/analyticsStore";

export const handleNavigateToAnalytics = (
  siteName: string,
  parentGroupId: string,
  siteId: string,
  navigate: NavigateFunction
) => {
  localStorage.setItem("navigatedToAnalyticsFromSitesPage", "true");
  localStorage.setItem("analyticsParentGroupId", parentGroupId);
  localStorage.setItem("analyticsSiteId", siteId);
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 5);
  const endDate = new Date();
  useAnalyticsStore.setState({
    siteDropDownValue: [siteName],
    cameraDropDownValue: [],
    alertGraphName: "Site",
    userFilters: {
      parent_group: parentGroupId,
      site: [siteId],
      camera: [],
      start_date: startDate,
      end_date: endDate,
    },
    filtersSavedClicked: false,
  });
  navigate("/analytics");
};
